import { render } from "./createBusinessUnit.vue?vue&type=template&id=2d9569b8&scoped=true"
import script from "./createBusinessUnit.vue?vue&type=script&lang=js"
export * from "./createBusinessUnit.vue?vue&type=script&lang=js"

import "./createBusinessUnit.vue?vue&type=style&index=0&id=2d9569b8&scoped=true&lang=css"

import exportComponent from "/home/quantum/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9569b8"]])

export default __exports__